import {createSelector} from "reselect";

export const poInformationSelector = createSelector(state => state && state.damage && state.damage.poInformation, poInformationSelector=> poInformationSelector);

export const allDamagesSelector = createSelector(state => state && state.damage && state.damage.allDamages, allDamagesSelector=> allDamagesSelector);
export const specificDamageSelector = createSelector(state => state && state.damage && state.damage.specificDamage, specificDamageSelector=> specificDamageSelector)